
import { Injectable } from '@angular/core';
import { AbstractFormActionHandler } from '../abstract-form-action-handler';
import { FormService } from '../../../form.service';
import { HandlePhoneCountryCodeContactPersonActionHandler } from './handle-phone-country-code-contact-person-action-handler';

@Injectable()
export class HandleSecondaryMobileCountryCodeContactPersonActionHandler extends HandlePhoneCountryCodeContactPersonActionHandler {

    protected getPhoneCountryCodeDatamodelField(): string {
        return 'secondaryMobileCountryCode';
    }

    protected getPhoneAreaCodeDatamodelField(): string {
        return 'secondaryMobileAreaCode';
    }

    protected getPhoneNumberDatamodelField(): string {
        return 'secondaryMobileNumber';
    }
}
